<template>
    <card v-if="query" class="card-plain user-questionnaire">
        <div class="card-body p-0 ml-3" v-if="questions">
          <div class="row">
            <div class="col-md-12">
              <basic-query-result v-model="questions" :active="active"/>
            </div>
          </div>
        </div>
    </card>
</template>

<script>
  import BasicQueryResult from '../../Dashboard/Components/BasicQueryResult'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'QueryResult',
    components: { BasicQueryResult },
    props: {
      active: {
        type: Boolean,
        default: true
      }
    },
    mounted () {
      this.getItem({ id: this.$route.params.id })
    },
    computed: {
      ...mapGetters({
        getById: 'user/queries/getById',
        getQuestionsGropedByType: 'user/queries/getQuestionsGropedByType'
      }),
      query: function () {
        return this.getById(this.$route.params.id)
      },
      questions: function () {
        return this.getQuestionsGropedByType(this.$route.params.id)
      },
      breadcrumb: function () {
        const breadcrumb = [
          { name: 'Queries', label: 'My Queries' }
        ]

        const { id } = this.$route.params
        if (id && this.query) {
          const label = this.$options.filters.languageString(this.query.title)
          breadcrumb.push({ name: 'QueryResult', params: { id }, label })
        }

        return breadcrumb
      }
    },
    methods: {
      ...mapActions('user/queries', ['getItem'])
    },
    watch: {
      breadcrumb () {
        this.$store.commit('breadcrumb/SET_ROUTE_DATA', {
          path: this.$route.path,
          breadcrumb: this.breadcrumb
        }, { root: true })
      }
    }
  }
</script>